function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.695 2.30485C10.4372 1.04706 8.77314 0.333496 6.99967 0.333496C3.33673 0.333496 0.333008 3.33131 0.333008 7.00016C0.333008 10.6709 3.32975 13.6668 6.99967 13.6668C10.6535 13.6668 13.6663 10.6827 13.6663 7.00016C13.6663 5.2267 12.9528 3.56264 11.695 2.30485ZM6.99967 12.0783C4.19275 12.0783 1.92155 9.81305 1.92155 7.00016C1.92155 5.90639 2.2653 4.86732 2.89811 4.00795L9.99189 11.0939C9.13246 11.7345 8.09345 12.0783 6.99967 12.0783ZM11.0934 9.99232L4.00746 2.8986C4.86689 2.26579 5.9059 1.92204 6.99967 1.92204C9.80668 1.92204 12.0778 4.18727 12.0778 7.00016C12.0778 8.09389 11.734 9.13295 11.0934 9.99232Z",
  fill: "#96A0B0"
});

var SvgBlockIcon = function SvgBlockIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBlockIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/blockIcon.a3b24c38.svg";
export { ForwardRef as ReactComponent };